import {Trans, useTranslation} from "ni18n";
import React from "react";

import {IllustratedTextDecoration} from "../IllustratedTextDecoration";
import {Btn, ImgWithBg} from "../V5Comp";

type Props = {
  jobCount: number;
  h1?: string;
  subheader?: JSX.Element | string;
  img?: string;
  alt?: string;
  caption?: JSX.Element;
  backgroundPosition?: string;
};

const Hero: React.FC<Props> = ({
  jobCount,
  h1,
  subheader,
  img,
  alt,
  caption,
  backgroundPosition,
}) => {
  const i18n = useTranslation();

  return (
    <ImgWithBg
      id="hero"
      bgImage={img || "/woman-with-phone"}
      alt={alt}
      style={{backgroundPosition}}
    >
      <div
        className="h100p w100p pt100 pt70-xs ph8 ph5-xs pb40 pb14-xs pos-r"
        style={{
          background: "linear-gradient(230deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.6) 100%",
        }}
      >
        <div className="maxw80 ma df fdc white">
          {Boolean(jobCount) && (
            <div className="df aic mb6 mb3-xs">
              <span className="mr3 font-ir fs14">
                <Trans count={jobCount}>
                  We're hiring for <b>{{count: jobCount}} roles</b>
                </Trans>
              </span>
              <Btn
                id="button"
                fontSize={0.75}
                className="event-rM9BvY focus-bsDarkBlue3"
                href="#careers"
                aria-label={i18n.t("Click to view available job openings.")}
              >
                {i18n.t("View Openings")}
              </Btn>
            </div>
          )}

          <div className="mb6">
            <h1 className="fs60 fs40-md fs36-sm fs32-xs maxw60 maxw40-md maxw36-sm maxw22-xs">
              {h1 || (
                <Trans>
                  Making high-quality healthcare more accessible to{" "}
                  <span className="pos-r">
                    everyone.
                    <IllustratedTextDecoration type="underline" />
                  </span>
                </Trans>
              )}
            </h1>
            {subheader && <p className="fs18 font-cm ls-3 maxw26">{subheader}</p>}
          </div>
          <a
            href="#our-story"
            id="our-story"
            className="event-rM9BvY focus-bsDarkBlue3 wfc"
            aria-label={i18n.t("Click to navigate to the next section.")}
          >
            <span className="cIcon-arrow-down white fs40 fs30-sm fs24-xs" />
          </a>
        </div>
        {caption && (
          <div className="pos-a dn-md" style={{right: 30, bottom: 30}}>
            {caption}
          </div>
        )}
      </div>
    </ImgWithBg>
  );
};

export default Hero;
